'use client'

import Link from "next/link";
import { Mail } from "lucide-react";

const socialLinks = [
  { name: "RuTube", url: "https://rutube.ru/channel/31821757", icon: "/assets/images/rutube.jpeg", banned: false },
  { name: "Telegram", url: "https://t.me/vcentre_it", icon: "/assets/images/telegram.png", banned: true },
  { name: "YouTube", url: "https://www.youtube.com/@VcentreIT", icon: "/assets/images/youtube.jpeg", banned: true },
  { name: "VK", url: "https://vk.com/vcentre_it", icon: "/assets/images/vk.jpeg", banned: false },
  { name: "Dzen", url: "https://dzen.ru/vcentre", icon: "/assets/images/vk.jpeg", banned: false },
];

const BannedStar = () => (
  <span
    aria-label="Запрещённая в РФ соцсеть"
    title="Запрещённая в РФ соцсеть"
    className="absolute -top-1.5 -right-1.5 flex h-3.5 w-3.5 items-center justify-center rounded-full bg-[hsl(var(--deep-black))] text-[10px] font-bold leading-none text-red-500"
  >
    ★
  </span>
);

const columns = [
  {
    title: "Платформа",
    links: [
      { to: "/platform", label: "Обзор платформы" },
      { to: "/platform/crm", label: "CRM и клиенты" },
      { to: "/platform/app", label: "Приложение компании" },
      { to: "/platform/websites", label: "Сайты" },
      { to: "/platform/communications", label: "Коммуникации" },
      { to: "/platform/integrations", label: "Интеграции" },
      { to: "/platform/modules", label: "Расширения" },
    ],
  },
  {
    title: "Решения",
    links: [
      { to: "/platform/solutions", label: "Все решения" },
      { to: "/platform/solutions/services", label: "Услуги и сервис" },
      { to: "/platform/solutions/commerce", label: "Торговля и e-commerce" },
      { to: "/platform/solutions/b2b", label: "B2B и продажи" },
      { to: "/platform/solutions/events", label: "Мероприятия и сообщества" },
      { to: "/platform/solutions/education", label: "Образование, эксперты и подписки" },
      { to: "/platform/solutions/online-offline", label: "Онлайн + офлайн клиенты" },
    ],
  },
  {
    title: "Компания",
    links: [
      { to: "/platform/company", label: "О компании" },
      { to: "/platforms", label: "Платформы VCENTRE.IT" },
      { to: "/store", label: "Магазин VCENTRE" },
      { to: "/platform/achievements", label: "Достижения" },
      { to: "/platform/news", label: "Новости" },
      { to: "/platform/events", label: "Мероприятия" },
      { to: "/platform/vacancies", label: "Сотрудничество" },
      { to: "/platform/partners", label: "Партнёрам" },
      { to: "/platform/investors", label: "Инвесторам" },
    ],
  },
  {
    title: "Помощь",
    links: [
      { to: "/platform/support", label: "Поддержка" },
      { to: "/platform/contacts", label: "Контакты" },
      { to: "/platform/pricing", label: "Тарифы" },
      { to: "/platform/cases", label: "Кейсы" },
      { to: "/platform/promotion", label: "Продвижение" },
    ],
  },
];

const Footer = () => {
  return (
    <footer className="vcentre-public-portal mt-8 border-t border-border/60 bg-[hsl(var(--deep-black))]/80">
      <div className="container-page py-14">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr_1fr]">
          <div>
            <Link href="/platform" className="mb-4 inline-flex items-center">
              <img src={"/assets/images/vcentreone.png"} alt="VCENTRE.ONE" className="h-9 w-auto" />
            </Link>
            <p className="body-text mb-5 max-w-sm">
              VCENTRE.ONE — центральная платформа экосистемы VCENTRE: клиенты, продажи, коммуникации, цифровые каналы и процессы бизнеса в одном рабочем контуре.
            </p>
            <div className="flex flex-wrap items-center gap-2">
              {socialLinks.map((s) => (
                <a
                  key={s.name}
                  href={s.url}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={s.name}
                  className="relative overflow-visible rounded-xl border border-border/70 transition-colors hover:border-primary/50"
                >
                  {s.banned && <BannedStar />}
                  <img src={s.icon} alt={s.name} className="h-9 w-9 object-cover" loading="lazy" />
                </a>
              ))}
            </div>
            <p className="body-text mt-3 max-w-sm text-xs text-muted-foreground">
              <span className="font-bold text-red-500">★</span> — запрещённые в Российской Федерации социальные сети.
            </p>
            <a
              href="mailto:help@vcentre.pro"
              className="mt-5 inline-flex items-center gap-2 text-sm text-muted-foreground transition-colors hover:text-primary"
            >
              <Mail className="h-4 w-4" /> help@vcentre.pro
            </a>
          </div>

          {columns.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <p className="mb-4 text-sm font-bold uppercase tracking-[0.14em] text-primary">{col.title}</p>
              <ul className="flex flex-col gap-2.5">
                {col.links.map((l) => (
                  <li key={l.to}>
                    <Link href={l.to} className="text-sm text-muted-foreground transition-colors hover:text-foreground">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="hairline my-10" />

        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} VCENTRE.IT · Платформа VCENTRE.ONE
          </p>
          <div className="flex flex-wrap items-center gap-4">
            <Link href="/signin?source=footer" className="btn-link">
              Начать с VCENTRE
            </Link>
            <Link href="/signin" className="text-xs text-muted-foreground hover:text-foreground">
              Войти
            </Link>
            <Link href="/policy" className="text-xs text-muted-foreground hover:text-foreground">Политика конфиденциальности</Link>
            <Link href="/access_pd" className="text-xs text-muted-foreground hover:text-foreground">Обработка персональных данных</Link>
            <Link href="/license" className="text-xs text-muted-foreground hover:text-foreground">Условия использования</Link>
          </div>
        </div>
      </div>

    </footer>
  );
};

export default Footer;
